import * as React from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { EASE_PREMIUM, MOTION, RISE_Y } from '@/lib/motion';

export function Reveal({
  children,
  index = 0,
  delay = 0,
  base = MOTION.stageDelay,
  className,
}: {
  children: React.ReactNode;
  index?: number;
  delay?: number;
  base?: number;
  className?: string;
}) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduced ? { opacity: 0 } : { opacity: 0, y: RISE_Y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: reduced ? MOTION.reducedEnter : MOTION.reveal,
        ease: EASE_PREMIUM,
        delay: reduced ? 0 : base + index * MOTION.stagger + delay,
      }}
    >
      {children}
    </motion.div>
  );
}
